// src/modules/meal/services/feedbackService.js

import authService from '../../auth/services/authService';
import { buildApiUrl } from '../../../config/api';

// Helper para manejar respuestas y redirigir en caso de 401
const handleResponse = async (response) => {
    if (response.status === 401) {
        authService.logout();
        window.location.href = '/login';
        throw new Error('Token expirado');
    }
    return response;
};

export const feedbackService = {
    /**
     * Enviar feedback sobre una comida
     */
    async sendFeedback(feedbackData) {
        const response = await fetch(buildApiUrl('/api/user/feedback'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authService.getToken()}`,
            },
            credentials: 'include',
            body: JSON.stringify({ feedback: feedbackData }),
        });

        await handleResponse(response);

        if (!response.ok) {
            throw new Error('Error al enviar el feedback');
        }

        return await response.json();
    },

    /**
     * Obtener feedback del usuario
     */
    async getFeedback() {
        const response = await fetch(buildApiUrl('/api/user/feedback'), {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${authService.getToken()}`,
            },
            credentials: 'include',
        });

        await handleResponse(response);

        if (!response.ok) {
            throw new Error('Error al obtener el feedback');
        }

        return await response.json();
    }
};
